<div class="strength indicators">
    <i class="mr-xxs cursor-pointer" nz-popover="" nzPopoverTitle="" [nzPopoverContent]="strengthPasswordTooltip" nz-icon nzType="info-circle" nzTheme="outline"></i>
    <ul class="strengthBar">
      <li class="point" [ngClass]="barColorClass0"></li>
      <li class="point" [ngClass]="barColorClass1"></li>
      <li class="point" [ngClass]="barColorClass2"></li>
      <li class="point" [ngClass]="barColorClass3"></li>
    </ul>
    <span class="text-info text-info-sm pl-xxs" @fadeInAnimation>{{strengthPassword}}</span>
</div>
